<template>
  <div>
    <McButton
      variant="secondary"
      icon="icon-outline_close"
      :disabled="disabled"
      :screenBreakpoint="screenBreakpoint"
      :displayTooltip="displayTooltip"
      :tooltipPosition="tooltipPosition"
      :text="$t('global.action.cancel')"
      @click="$bvModal.show('mc-modal-cancel')"
    />

    <b-modal
      class="mc-modal"
      id="mc-modal-cancel"
      ref="mc-modal-cancel"
      :title="$t('global.action.cancel')"
      size="md"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <p>{{ `${$t('global.text.modal.cancelChange')}?` }}</p>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex mx-0">
          <McButton
            @click="cancel()"
            variant="secondary"
            class="me-2"
            :text="$t('global.action.no')"
          />
          <McButton @click="handleSubmit" variant="primary" :text="$t('global.action.yes')" />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    screenBreakpoint: {
      type: Number,
      default: null,
    },
    displayTooltip: {
      type: Boolean,
      default: false,
    },
    tooltipPosition: {
      type: String,
      default: 'left',
    },
  },
  methods: {
    handleSubmit() {
      this.$router.go(-1)
    },
  },
}
</script>
